import { useState, useMemo } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Box, } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useApi} from '/@/app/Api';
import { userFlowState } from '/@/app/states/userFlowState';

const LANGUAGES = [
	{ code: 'en', name: 'English', flag: '🇬🇧', },
	{ code: 'ru', name: 'Русский', flag: '🇷🇺', },
];

export default function LanguageSwitcher({ size = 'medium' })
{
const { i18n } = useTranslation();
const api=useApi();

const [anchorEl, setAnchorEl] = useState(null);

const currentLanguage = useMemo( () =>
	LANGUAGES.find(lang => i18n.language.startsWith(lang.code)) || LANGUAGES[0], [i18n.language]
);

const handleOpen = (event) =>
{
	setAnchorEl(event.currentTarget);
};

const handleClose = () =>
{
	setAnchorEl(null);
};

const handleChangeLanguage = (lang) =>
{
	i18n.changeLanguage(lang);
	const re=api.request( `user/settings`,{ 'lang':lang }, { method:'POST', api_url:'v2', supress_nonauth:true}).then((re)=>
	{
		userFlowState.setCalculateRequired({isRequired: true, postponeForLocation: null});
	});
	localStorage.setItem('lang',lang);
	handleClose();
};

return (
<>
<IconButton size={size} onClick={handleOpen} aria-label="language" >
<Box sx={{ fontSize: 24 }}> {currentLanguage.flag} </Box>
</IconButton>

<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} >
{LANGUAGES.map(lang => (
<MenuItem key={lang.code} selected={lang.code === currentLanguage.code} onClick={() => handleChangeLanguage(lang.code)} >
<ListItemIcon sx={{ minWidth: 36, fontSize: 22, }} > {lang.flag} </ListItemIcon>

<ListItemText> {lang.name} </ListItemText>
</MenuItem>
))}
</Menu>

</>
);
}
